import api from "../api";

// ---- Config ----
const VAPID_PUBLIC_KEY =
  "BBbDgE4Vr0JeWSWI6fXvi9bZ6lAizXl73aZ8BYIoGaHnz5e8f0bl7EAZO6fQjNUAwBiNUb8y8MB86rgcZoVnTOs";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// ---- Helpers ----
const DEVICE_ID_KEY = "pushDeviceId";
function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id =
        crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random()}`;
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return `${Date.now()}-${Math.random()}`;
  }
}

async function getCurrentSubscription() {
  if (!("serviceWorker" in navigator)) return null;
  const registration = await navigator.serviceWorker.ready;
  return await registration.pushManager.getSubscription();
}

function buildBackendPayload(subscription) {
  const json = subscription.toJSON();
  return {
    endpoint: json.endpoint,
    keys: {
      p256dh: json.keys?.p256dh,
      auth: json.keys?.auth,
    },
    deviceId: getOrCreateDeviceId(),
    userAgent: navigator.userAgent,
  };
}

async function subscribeUser() {
  if (!("serviceWorker" in navigator)) {
    throw new Error("Trình duyệt không hỗ trợ Service Worker.");
  }
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  const payload = buildBackendPayload(subscription);
  await api.post("/api/dang-ky-thong-bao", payload);
  return subscription;
}

async function unsubscribeUser() {
  const subscription = await getCurrentSubscription();
  if (!subscription) {
    console.warn("Không tìm thấy subscription để hủy.");
    return;
  }
  await api.delete("/api/dang-ky-thong-bao", {
    data: { endpoint: subscription.endpoint },
  });

  const ok = await subscription.unsubscribe();
  if (!ok) console.error("Hủy subscription phía trình duyệt thất bại.");
}

// Lấy danh sách thiết bị đã đăng ký của current user
async function listMyDevices() {
  const { data } = await api.get("/api/dang-ky-thong-bao/me");
  return data;
}

// Hủy một thiết bị bất kỳ theo endpoint
async function removeDeviceByEndpoint(endpoint) {
  await api.delete("/api/dang-ky-thong-bao", { data: { endpoint } });
}

export const pushSubscriptionService = {
  getCurrentSubscription,
  subscribeUser,
  unsubscribeUser,
  listMyDevices,
  removeDeviceByEndpoint,
};
